import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import i18next from 'i18next';
import { IsEnglish } from '../../utils/language';
import { withNamespaces } from 'react-i18next';
import { toDisplayDecimal } from '../../utils';

const useStyles = makeStyles({
    table: {
    },
    detail: {
        textAlign: 'left',
        '& > div': {
            padding: '6px'
        }
    }
});

function ScheduleSummaryDetailClient(props) {
    const classes = useStyles();
    const [projectDescription, setProjectDescription] = React.useState("");
    const [addressName, setAddressName] = React.useState("");
    const [address, setAddress] = React.useState("");
    const [clientDescription, setClientDescription] = React.useState("");
    const [requisitionCode, setRequisitionCode] = React.useState("");
    const [requisitionDescriptionF, setRequisitionDescriptionF] = React.useState("");
    const [requisitionDescriptionE, setRequisitionDescriptionE] = React.useState("");
    const [paidKM, setPaidKM] = React.useState("");

    useEffect(() => {
        if (props.data !== null && props.data !== undefined) {
            const projectDescription = IsEnglish() ? props.data?.projectDescriptionE : props.data?.projectDescriptionF;
            const address = IsEnglish() ? props.data?.addressEn : props.data?.addressFr;

            setProjectDescription(projectDescription);
            setAddressName(props.data?.nameAddress);
            setAddress(address);
            setClientDescription(props.data?.clientDescription);
            setRequisitionCode(props.data?.requisitionCode);
            setRequisitionDescriptionF(props.data?.personnelRequisitionCodeDescriptionF);
            setRequisitionDescriptionE(props.data?.personnelRequisitionCodeDescriptionE);
            setPaidKM(props.data?.paidKM);
        }
    }, [props.data]);

    return (
        <div className={classes.detail}>
            {clientDescription &&
                <div>
                    <span><b>{`${i18next.t('schedule:list.client')}${i18next.t('common:labelSeparator')} `}</b> {clientDescription} </span>
                </div>
            }
            {
                requisitionCode &&
                <div>
                    <span><b>{`${i18next.t('schedule:list.requisitionDescription')}${i18next.t('common:labelSeparator')} `}</b> {IsEnglish() ? requisitionDescriptionE : requisitionDescriptionF}</span>
                </div>
            }
            {
                (projectDescription || addressName) &&
                <div>
                    <span><b>{`${i18next.t('schedule:list.project')}${i18next.t('common:labelSeparator')} `}</b> {projectDescription || addressName}</span>
                </div>
            }
            {
                address &&
                <div>
                    <span><b>{`${i18next.t('schedule:list.address')}${i18next.t('common:labelSeparator')} `}</b> {address}</span>
                </div>
            }
            {
                paidKM &&
                <div>
                        <span><b>{`${i18next.t('schedule:list.PaidKM')}${i18next.t('common:labelSeparator')} `}</b> {toDisplayDecimal(paidKM, 2)}</span>
                </div>
            }
        </div>
    );
}

export default withNamespaces(['schedule', 'common'], { wait: true })(ScheduleSummaryDetailClient);